import { render, staticRenderFns } from "./ClientDetailView.vue?vue&type=template&id=3c0f4e56&scoped=true"
import script from "./ClientDetailView.vue?vue&type=script&lang=js"
export * from "./ClientDetailView.vue?vue&type=script&lang=js"
import style0 from "./ClientDetailView.vue?vue&type=style&index=0&id=3c0f4e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0f4e56",
  null
  
)

export default component.exports